import React, { ReactNode, useContext, useEffect, useState } from "react";
import PizzaWallpaperTemp from "../../../assets/images/pizza_logo_cardapio.png"

import ImageLogoComponent from "../../../components/Image/ImageLogoComponent";
import BoxComponent from "../../../components/Box/BoxComponent";
import ContainerComponent from "../../../components/Container/ContainerComponent";

import TextFieldComponent from "../../../components/TextField/TextFieldComponent";
import SearchIcon from "../../../assets/icons/search_icon.png";

import { ReactComponent as PratoTalheresIcon } from "../../../assets/icons/prato_talheres.svg";
import { ReactComponent as PizzasIcon } from "../../../assets/icons/pizzas.svg";
import { ReactComponent as HamburguerIcon } from "../../../assets/icons/hamburguer.svg";
import { ReactComponent as CombosIcon } from "../../../assets/icons/combos.svg";
import { ReactComponent as BebidasIcon } from "../../../assets/icons/bebidas.svg";
import { ReactComponent as EntradasIcon } from "../../../assets/icons/entradas.svg";

import ImageComponent from "../../../components/Image/ImageComponent";

import "../../../assets/styles/images.css";
import { EmpresaContext } from "../../../provider/empresa/EmpresaContext";
import { catalogoService } from "../../../service/CatalogoService";
import { pedidoService } from "../../../service/PedidoService";
import { ResponseErrorDTO } from "../../../api/ResponseProps";
import axios from "axios";
import { PedidoDTO } from "../../../interface/Pedido";
import HeaderComponent from "./components/HeaderComponent";
import InfosEntregaComponent from "./components/InfosEntregaComponent";
import InfoFidelidadeComponent from "./components/InfoFidelidadeComponent";
import CategoriasComponent from "./components/CategoriasComponent";
import DestaquesComponent from "./components/DestaquesComponent";
import MaisPedidosComponent from "./components/MaisPedidosComponent";
import CarrinhoComponent from "./components/carrinho/CarrinhoComponent";
import { CatalogoDisponibilidadeDTO } from "../admin/components/CatalogoAdminPrincipal";
import ModalDetalhesInfoPedidoComponent from "./components/item/ModalDetalhesInfoPedidoComponent";
import ModalDetalhesItemComponent from "./components/item/ModalDetalhesItemComponent";

export interface ItemDestaque {
    id: number;
    idCategoria: number;
    titulo: string;
    descricao: string;
    status?: string;
    precoAnterior?: number;
    precoAtual?: number;
    ofertaEspecial: boolean;
    novo: boolean;
    desconto: number | null;
    midias?: ItemDestaqueMidia[];
    ativo: boolean;

    promocao: boolean;
    delivery: boolean;
    mesa: boolean;
    balcao: boolean;
    custoAutomatico: boolean;

    precoVenda?: number;
    precoVendaStr?: string;

    precoCusto?: number;
    precoCustoStr?: string;

    disponibilidade: CatalogoDisponibilidadeDTO[];

    opcao: CatalogoOpcao;
    complementos: CatalogoItemComplemento[];
    complementosEspecificos: CatalogoComplementoEspecifico[];

    pdv: string;
    etiqueta: string;
}

export interface ItemCatalogo {
    id?: number;
    titulo?: string;
    descricao?: string;
    status?: string;

    precoAnterior?: number;
    precoAtual?: number;
    ofertaEspecial?: boolean;
    novo?: boolean;
    desconto?: number;

    midias: ItemDestaqueMidia[];

    ativo?: boolean;

    precoVenda?: number;
    precoCusto?: number;

    etiqueta?: string;
    pdv?: string;

    promocao?: boolean;
    custoAutomatico?: boolean;
}

export interface ItemDestaqueMidia {
    id?: number;
    ativo: boolean;
    caminho: string;
    nome: string;
}

export interface ItemMaisPedido {
    titulo: string;
    descricao: string;
    precoAnterior: number | null;
    precoAtual: number;
    image: ReactNode;
    flag: "NOVIDADE" | "EDIÇÃO LIMITADA" | "MAIS PEDIDO" | null;
    midias?: ItemDestaqueMidia[]
}

export interface ItemCarrinho {
    item: ItemDestaque,
    qtd: number;
    vlrUnitario: number;
    observacao?: string
}

export interface CategoriasProps {
    label: string;
    value: string;
    icon: ReactNode;
}

export interface CatalogoComplemento {
    id?: number,
    nome: string;
    vlrUnitario: number;
    vlrUnitarioStr: string | null;
    ativo: boolean
    qtdItens: number;
}

export interface CatalogoItemComplemento {
    id?: number,
    nome: string;
    vlrUnitario: number;
    vlrUnitarioStr: string | null;
    ativo: boolean;
    selecionado: boolean;
}

export interface CatalogoOpcao {
    id?: number,
    //idEmpresa: number;
    nome: string;
    tipo: string;
    descricao: string;
    ativo: boolean
}

export interface CatalogoComplementoEspecifico {
    id?: number;
    nome: string;
    vlrUnitario: number;
    vlrUnitarioStr: string | null;
    ativo: boolean;
    index?: number // preciso para controlar
}

// NECESSÁIRO PARA PEDIDO
export interface CatalogoComplementoSelecionado {
    id: number;
    nome: string;
    vlrUnitario: number
}

export interface DetalheItem {
    id: number | null;
    nome: string;
    qtd: number;
    midias?: ItemDestaqueMidia[];
    subtotal: number; // Apenas o valor unitário
    opcao?: CatalogoOpcao;
    complementos?: CatalogoComplementoSelecionado[];
    complementosEspecificos?: CatalogoComplementoSelecionado[];
    observacao?: string;
}

export interface ModalDetalheCatalogo {
    open: boolean;
    item?: ItemDestaque
}

const CatalogoPage = () => {
    // const { empresa } = useParams();

    const { empresa, loading } = useContext(EmpresaContext);

    const [categoriaSelecionada, setCategoriaSelecionada] = useState<string>("TODOS");

    //const [infoEmpresa, setInfoEmpresa] = useState<infoEmpresa>();

    const [categorias, setCategorias] = useState<CategoriasProps[]>([]);

    const [itensDestaque, setItensDestaque] = useState<ItemDestaque[]>();

    const [itensMaisPedidos, setItensMaisPedidos] = useState<ItemMaisPedido[]>();

    const handleCategoriaSelecionada = (categoria: string) => {
        setCategoriaSelecionada(categoria);
    }

    useEffect(() => {
        if (!empresa) return;

        if (empresa.id != null) {
            getCatalogo(empresa.id);
            getCategorias(empresa.id);
            getItensMaisPedidos(empresa.id);
        }

    }, [empresa, categoriaSelecionada]);

    const getCatalogo = async (id: number) => {
        try {
            const data = await catalogoService.getCatalogo(id, categoriaSelecionada);
            setItensDestaque(data);
        } catch (e) {
            console.error(e);
        }
    }

    const getCategorias = async (id: number) => {
        try {
            const categoriasApi = await catalogoService.getCategorias(id);

            const categoriasFormatadas: CategoriasProps[] = [
                { label: "Todos", value: "TODOS", icon: <PratoTalheresIcon /> }
            ];

            if (Array.isArray(categoriasApi)) {
                categoriasApi.forEach((item: CategoriasProps) => {
                    let icon;

                    if (item.label.includes("Pizza")) icon = <PizzasIcon />;
                    else if (item.label.includes("Hambúrguer")) icon = <HamburguerIcon />;
                    else if (item.label.includes("Combos")) icon = <CombosIcon />;
                    else if (item.label.includes("Bebidas")) icon = <BebidasIcon />;
                    else if (item.label.includes("Entradas")) icon = <EntradasIcon />;

                    categoriasFormatadas.push({
                        label: item.label,
                        value: item.value,
                        icon
                    });
                });
            }

            setCategorias(categoriasFormatadas);

        } catch (e) {
            console.error(e);
        }
    }

    const getItensMaisPedidos = async (id: number) => {
        try {
            const data = await catalogoService.getMaisPedidos(id);
            setItensMaisPedidos(data);
        } catch (e) {
            console.error(e);
        }
    }

    const mountLikeItem = (item: ItemDestaque) => {
        alert("LIKE EM ITEM - A TRABALHAR");
    }

    const [itensCarrinho, setItensCarrinho] = useState<DetalheItem[]>([]);

    const [modalDetalheCatalogo, setModalDetalheCatalogo] = useState<ModalDetalheCatalogo>({
        open: false,
        item: undefined
    });

    const handleClickModalDetalheCatalogo = (item: ItemDestaque) => {
        setModalDetalheCatalogo({
            open: true,
            item: item
        });
    }

    const handleCloseModalDetalheCatalogo = () => {
        setModalDetalheCatalogo({
            open: false,
            item: undefined
        });
    }

    const mountItemCarrinho = (
        novoItem: DetalheItem
    ) => {
        setItensCarrinho((prev: any) => catalogoService.mountItemCarrinho(prev, novoItem));
        handleCloseModalDetalheCatalogo();
    };

    useEffect(() => {
        console.log("tive alteracao", itensCarrinho)
    }, [itensCarrinho])

    const handleSubmitPedido = async (pedido: PedidoDTO) => {
        if (pedido == null) {
            return;
        }

        var form = new FormData();
        form.append("idEmpresa", String(pedido.idEmpresa ?? ""));
        //form.append("idFormaPgto", String(pedido.idFormaPgto?? ""));
        if (pedido.formaPagamento != null || pedido.formaPagamento != undefined) form.append("formaPagamento", JSON.stringify(pedido.formaPagamento));
        //form.append("formaPagamento", JSON.stringify(pedido.formaPagamento));
        form.append("tipo", pedido.tipo);
        form.append("observacao", pedido.observacao || "");
        if (pedido.dadosSolicitante != null || pedido.dadosSolicitante != undefined) form.append("dadosSolicitante", JSON.stringify(pedido.dadosSolicitante));
        form.append("nomeCliente", pedido.nomeCliente);

        for (let i = 0; i < pedido.itens.length; i++) {
            const itemCarrinho = pedido.itens[i];

            form.append(`itens[${i}].idCatalogo`, String(itemCarrinho.item.id));
            form.append(`itens[${i}].qtd`, itemCarrinho.qtd.toString());

            // Complementos
            const complementos = itemCarrinho.complementos;
            if (Array.isArray(complementos) && complementos !== null) {
                complementos.forEach((complemento: any, j: number) => {
                    form.append(`itens[${i}].complementos[${j}].id`, String(complemento.id));
                    form.append(`itens[${i}].complementos[${j}].nome`, complemento.nome);
                    form.append(`itens[${i}].complementos[${j}].vlrUnitario`, String(complemento.vlrUnitario));
                    //form.append(`itens[${i}].complementos[${j}].ativo`, String(complemento.ativo));
                });
            }

            const complementosEspecificos = itemCarrinho.complementosEspecificos;
            if (Array.isArray(complementosEspecificos) && complementosEspecificos !== null) {
                // Complementos específicos
                complementosEspecificos.forEach((complemento: any, j: number) => {
                    form.append(`itens[${i}].complementosEspecificos[${j}].id`, String(complemento.id));
                    form.append(`itens[${i}].complementosEspecificos[${j}].nome`, complemento.nome);
                    form.append(`itens[${i}].complementosEspecificos[${j}].vlrUnitario`, String(complemento.vlrUnitario));
                });
            }

            // Opção
            form.append(`itens[${i}].opcao.id`, String(itemCarrinho.opcao.id));
            form.append(`itens[${i}].opcao.idEmpresa`, String(pedido.idEmpresa ?? ""));
            form.append(`itens[${i}].opcao.nome`, String(itemCarrinho.opcao.nome));
            form.append(`itens[${i}].opcao.tipo`, String(itemCarrinho.opcao.tipo));
            form.append(`itens[${i}].opcao.descricao`, String(itemCarrinho.opcao.descricao));
        }

        form.append("endereco", JSON.stringify(pedido.endereco));

        try {
            const response = await pedidoService.registerPedido(form);
            alert(response.data.mensagem);
            setItensCarrinho([]);
        } catch (e: unknown) {
            if (axios.isAxiosError<ResponseErrorDTO>(e)) {
                const mensagem =
                    e.response?.data?.message || "Erro ao processar pedido";

                alert(mensagem);
            } else {
                alert("Erro inesperado");
            }
        }
    }

    if (empresa == null) return;

    return (
        <>
            <ModalDetalhesItemComponent
                open={modalDetalheCatalogo.open}
                onClose={handleCloseModalDetalheCatalogo}
                item={modalDetalheCatalogo.item}
                onClickEscolha={mountItemCarrinho}
                empresa={empresa}
            />

            {/* PAPEL DE PAREDE */}
            <BoxComponent
                component="section"
                className="container-image-transparent"
            >
                <ImageComponent
                    src={PizzaWallpaperTemp}
                    alt="img-transparente-baixo"
                    className="img-transparente-baixo"
                />
            </BoxComponent>

            {/* HEADER RESTAURANTE */}
            <HeaderComponent
                nomeEmpresa={empresa?.titulo}
                imageLogo={empresa?.logo}
                descricao={empresa?.descricao}
                cidade={empresa?.cidade} uf={empresa.uf}
                aberto={empresa?.aberto}
                horarioFechamento={empresa?.horarioFechamento}
                onClickMaisInfo={() => alert("cliquei em mais informações")}
            />

            {/* BOTAO TAXA E TEMPO ENTREGA */}
            {empresa.disponivelEntregas && (
                <InfosEntregaComponent
                    onClickEntrega={() => alert("Quero saber sobre entregas!")}
                />
            )}

            {/* BOTAO PROGRAMA FIDELIDADE */}
            {empresa.programaFidelidade && (
                <InfoFidelidadeComponent
                    descricao="A cada R$ 1,00 em compras você ganha 1 ponto que pode ser trocado por prêmios"
                    onClickFidelidade={() => alert("Quero saber sobre fidelidade!")}
                />
            )}

            {/* BUSCA */}
            <ContainerComponent
                component="section"
                sx={{
                    display: 'flex',
                    alignItems: "center",
                    width: "100%",
                    mt: 3
                }}
            >
                <BoxComponent
                    component="article"
                    sx={{
                        display: "flex",
                        alignContent: "center",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        backgroundColor: "#E5E7EB",
                        borderRadius: "10px",
                        height: "50px",
                        width: {
                            xs: "100%",
                            sm: "100%",
                            md: "100%",
                            lg: "70%",
                            xl: "70%"
                        },
                        gap: 2
                    }}
                >
                    <ImageLogoComponent
                        sx={{
                            margin: 1.85,
                            width: 20,
                            height: 20
                        }}
                        src={SearchIcon}
                        alt="icone_pesquisa_produto"
                    />
                    <TextFieldComponent
                        id="busca_produto"
                        placeholder="Busque por um produto"
                        variant="standard"
                        disableUnderline
                        fullWidth
                        onInput={(e) => {
                            const target = e.target as HTMLInputElement;
                        }}
                    />
                </BoxComponent>
            </ContainerComponent>

            {/* CATEGORIAS */}
            <CategoriasComponent
                categoriaSelecionada={categoriaSelecionada}
                categorias={categorias}
                onClickCategoriaSelecionada={(categoria: string) => handleCategoriaSelecionada(categoria)}
            />

            {/* DESTAQUES */}
            {itensDestaque && (
                <DestaquesComponent
                    itensDestaque={itensDestaque}
                    onClickCarrinho={(item: ItemDestaque) => handleClickModalDetalheCatalogo(item)}
                    onClickLike={(item: ItemDestaque) => mountLikeItem(item)}
                />
            )}

            {/* MAIS PEDIDOS */}
            {itensMaisPedidos && (
                <MaisPedidosComponent
                    itensMaisPedidos={itensMaisPedidos}
                />
            )}

            {itensCarrinho && (
                <CarrinhoComponent
                    itens={itensCarrinho}
                    setItens={setItensCarrinho}
                    handleSubmitPedido={(pedido: PedidoDTO) => handleSubmitPedido(pedido)}
                    limpaCarrinho={() => setItensCarrinho([])}
                />
            )}

            {/* <LoginModal
                open={openModalLogin}
                onClose={() => setOpenModalLogin(false)}
            /> */}
        </>
    );
}

export default CatalogoPage;